import { defineStore } from 'pinia'
import { flatten } from 'lodash'
import repositoryFactory from '@/factories/repository-factory'
import WeatherWarning2Repository from '@/repositories/weather-warning2-repository'
import WeatherWarning2 from '@/models/WeatherWarning2'
import { Area, ALERT_KIND_STATUSES } from '@/models/WeatherWarning'
import { resolveAlertLevel } from '@/models/weatherWarningCode'

const storeKey = 'weatherWarning'

type Store = {
  weatherWarningData: WeatherWarning2[]
}

export const useWeatherWaringStore = defineStore(storeKey, {
  state: () =>
    ({
      weatherWarningData: [] as WeatherWarning2[],
    } as Store),

  actions: {
    async fetch(areaList: Area[]) {
      const repository = (await repositoryFactory.create()).get('weatherWarning2') as WeatherWarning2Repository

      this.weatherWarningData = await Promise.all(areaList.map(area => repository.get(area.code.toString())))
    },
  },

  getters: {
    // 注意報警報画面と同様に、解除以外（発表中）の kind・河川情報の警戒レベルをコード辞書から判定し、最大値を返す
    maxAlertLevel: state => {
      const kindCodes = flatten(state.weatherWarningData.map(value => value.kinds))
        .filter(kind => kind.status !== ALERT_KIND_STATUSES.CANCEL)
        .map(kind => kind.code)
      const riverCodes = flatten(state.weatherWarningData.map(value => value.rivers)).map(river => river.kindCode)
      const levels = [...kindCodes, ...riverCodes].map(code => resolveAlertLevel(code))

      if (levels.length == 0) {
        return 0
      }

      const maxLevel = Math.max(...levels)
      return `weather_warn${maxLevel}`
    },
  },
})
